import React from "react";
import GitBrowser from "../gitFileslist";

interface PolicyTypeTabProps {
  policyMode: "existing" | "new" | undefined;
  setPolicyMode: (mode: "existing" | "new" | undefined) => void;
  handleExistingPolicySelect: (repoURL: string, branch: string, filePath: string) => Promise<void>;
  onProceed: () => void;
}

const PolicyTypeTab: React.FC<PolicyTypeTabProps> = ({
  policyMode,
  setPolicyMode,
  handleExistingPolicySelect,
  onProceed
}) => {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Start managing your policy</h2>
      <div className="space-y-6">
        <div>
          <label className="font-medium text-sm mb-2 block">
            Define Policy Requirement
          </label>
          <div className="flex gap-6">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="policyMode"
                value="existing"
                checked={policyMode === "existing"}
                onChange={() => setPolicyMode("existing")}
              />
              Existing
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="policyMode"
                value="new"
                checked={policyMode === "new"}
                onChange={() => setPolicyMode("new")}
              />
              New
            </label>
          </div>
        </div>

        {policyMode === "existing" && (
          <div>
            <GitBrowser handleExistingPolicySelect={handleExistingPolicySelect} onProceed={onProceed} />
         
          </div>
          
        )}

        {policyMode === "new" && (
          <div className="flex gap-4 mt-4">
            <button
              className="px-4 py-2 text-white rounded bg-primary"
              onClick={onProceed}
            >
              Proceed
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PolicyTypeTab;
